import { styled, theme, utils } from 'ui/theme';
import { ButtonIcon } from 'ui/components/primitives';

export const DRAWER_TRANSITION_TIME = utils.duration.standard;

const size = {
  auto: 'auto',
  default: '464px',
  '3x4': '75%',
};

export const Drawer = {
  Component: styled.div`
    ${utils.transition('all').easing('easeInOut').duration(DRAWER_TRANSITION_TIME)};
    background-color: ${theme.colors.build.lightDark1};
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    z-index: ${theme.zIndices.drawer};

    // Size variants
    &[data-size='auto'] {
      width: ${size.auto};
    }

    &[data-size='default'] {
      ${utils.media.min('m')`
        width: ${size.default};
    `}
    }

    &[data-size='3x4'] {
      width: ${size['3x4']};
    }

    // Anchor top
    &[data-anchor='top'] {
      ${utils.fixedTo.top}
      transform: translateY(-100%);

      &[data-open='true'] {
        transform: translateY(0);
        box-shadow: ${theme.shadows.down.mid};
      }

      &[data-size='auto'],
      &[data-size='default'],
      &[data-size='full'] {
        width: 100%;
      }

      &[data-size='full'] {
        height: 100%;
      }
    }

    // Anchor bottom
    &[data-anchor='bottom'] {
      ${utils.fixedTo.bottom}
      transform: translateY(100%);

      &[data-open='true'] {
        transform: translateY(0);
        box-shadow: ${theme.shadows.up.mid};
      }

      &[data-size='auto'],
      &[data-size='default'],
      &[data-size='full'] {
        width: 100%;
      }

      &[data-size='full'] {
        height: 100%;
      }
    }

    // Anchor bottom
    &[data-anchor='left'] {
      ${utils.fixedTo.left}
      transform: translateX(-100%);

      &[data-open='true'] {
        transform: translateX(0);
        box-shadow: ${theme.shadows.right.mid};
      }
    }

    // Anchor right
    &[data-anchor='right'] {
      ${utils.fixedTo.right}
      transform: translateX(100%);

      &[data-open='true'] {
        transform: translateX(0);
        box-shadow: ${theme.shadows.left.mid};
      }
    }
  `,

  Content: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    max-height: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    overflow: auto;
    padding: ${theme.space[0]};
  `,
};

export const DrawerHeader = {
  Component: styled.header`
    align-items: center;
    background-color: ${theme.colors.build.lightDark2};
    display: flex;
    height: ${theme.sizes[14]};
    justify-content: flex-start;
  `,
};

export const DrawerWithoutHeader = {
  Component: styled(ButtonIcon)`
    background: ${theme.colors.build.lightDark2};
    position: absolute;
    right: calc(-1 * ${theme.space[10]} - 2px);
    top: ${theme.space[4]};

    &[data-show='false'] {
      visibility: hidden;
    }
  `,
};
